import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Grid, Checkbox } from '@mui/material';
import LLPList from './LLPList';
import LLPEditModal from './LLPEditModal';
import LLPAddModal from './LLPAddModal';
import LLPBulkEditModal from './LLPBulkEditModal';
import useBulkSelectHook from '../hooks/useBulkSelectHook';
import { deleteLlpApi } from '../apiServices';
import DeletePopUp from '../../../shared_elements/components/DeletePopUp';
import { NoRecordFound, PageLoader, STableLoader, Pagination } from '../../../shared_elements';
import { globalDeleteService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import "../_shopvisit.scss"
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';

const LLPHd = ({ toggleBulkOps, item, bulk, isClaimApproved, hideActionsColumn }) => {
    return (
        <TableHead>
            <TableRow >
                <TableCell sx={{ position: 'sticky', left: 0, backgroundColor: '#e6ecff', zIndex: 11, }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
                        {!isClaimApproved ? <Checkbox
                            color='primary'
                            size='small'
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
                            checked={item?.length === bulk?.ids?.length && item?.length > 0}
                        /> : null}
                    </PermissionWrapper>
                </TableCell>
                {!hideActionsColumn ? <TableCell sx={{ position: 'sticky', left: 58, backgroundColor: '#e6ecff', zIndex: 11, }}> Action(s) </TableCell> : null}
                <TableCell > Module</TableCell>
                <TableCell sx={{width :"120px"}} > Description</TableCell>
                <TableCell  > Part Number</TableCell>
                <TableCell > Cycles Max Limit</TableCell>
                <TableCell> Cycles Remaining</TableCell>
                <TableCell> SV Cost</TableCell>
                <TableCell> Claim Amount</TableCell>
            </TableRow>
        </TableHead>
    );
};

const LLP = ({ shopVisit, claimInfo, getShopVisitFundBalance, llpList, llpListLoader, getLlpList, updateShopVisitLlpCost }) => {
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar()
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const assetData = leaseBasicDetails?.asset
    const [isLoading, setLoading] = useState({ buttonLoader: false });
    const llpInfo = llpList;
    const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
    const [deleteLLP, setDeleteLLP] = useState({ modal: false, data: null });
    const [editLLP, setEditLLP] = useState({ mode: '', modal: false, data: null });
    const [addLLP, setAddLLP] = useState({ mode: '', modal: false, data: null });
    const [bulkEditLLP, setBulkEditLLP] = useState({ modal: false, data: null });
    const { bulk, openBulkModal, toggleBulkOps, resetBulkToggle } = useBulkSelectHook()
    const [queryConfig, setQueryConfig] = useState();
    const onDeleteLLP = async () => {
        const idsToDelete = { ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? bulk?.ids?.map(item => item.id) : [deleteLLP?.data?.id] }
        toggleLoader("buttonLoader", true)
        const response = await globalDeleteService(deleteLlpApi(shopVisit?.asset_id), idsToDelete)
        if (checkApiStatus(response)) {
            trackActivity('Item Deleted', { page_title: `Delete Shop Visit LLP`, success_msg: response?.data?.message, item_ids: idsToDelete, response: response?.data })
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            setDeleteLLP({ modal: false, data: null });
            resetBulkToggle()
            getLlpList(shopVisit, queryConfig, 'pageLoader');
            getShopVisitFundBalance(shopVisit);
        } else {
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Deleted', { page_title: `Delete Shop Visit LLP`, error_msg: response?.data?.message, item_ids: idsToDelete, response: response?.data })
            return null
        }
    };
   
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit LLP`, page_type: page_type, })
    }
    const isSvApproved = shopVisit?.status?.value === 3;
    const isClaimApproved = Array.isArray(claimInfo?.list) && claimInfo.list.length > 0 && claimInfo.list.some((c) => c?.status?.value === 3);
    const hideActionsColumn = isClaimApproved && isSvApproved;
    return (
        <>
            <Paper style={{ maxHeight: `${window.innerHeight - 150}px`, padding: '10px', marginTop: "4px" }}>
                <div className=''>
                    <Grid container>
                        <Grid size={{ md: 12, sm: 12 }}>
                            <ul className='list-inline lease-details-right-items' style={{ paddingTop: 0 }}>
                                {
                                    !isClaimApproved && bulk?.type && bulk?.ids?.length ?
                                        <>
                                            {!isSvApproved ? <li>
                                                <Button onClick={() => { resetBulkToggle(); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                            </li> : null}
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                                                <li>
                                                    <Button onClick={() => { setBulkEditLLP({ modal: true, data: bulk?.ids }); handleItemClicked('Bulk Edit Button') }} variant="contained" size="small" color='primary'>{`Edit (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                            {!isSvApproved ? <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                                                <li>
                                                    <Button onClick={() => { openBulkModal(); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper> : null}
                                        </> : null
                                }
                                {!isSvApproved ? <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                                    <li> <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { setAddLLP({ modal: true, data: [], mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Item </Button> </li>
                                </PermissionWrapper> : null}
                            </ul>
                        </Grid>
                    </Grid>
                    <div className='lease-detail-table' >
                        {llpListLoader?.skeletonLoader || !assetData ? <STableLoader count={8} rowCount={3} /> : (<>
                            <Paper style={{ maxHeight: `${window.innerHeight - 550}px`, overflow: 'scroll' }}>
                                <Table className='mui-table-format' stickyHeader >
                                    <LLPHd item={llpInfo} toggleBulkOps={toggleBulkOps} bulk={bulk} isClaimApproved={isClaimApproved} hideActionsColumn={hideActionsColumn} />
                                    <TableBody>
                                        {llpInfo?.length > 0 && llpInfo?.map((item, index) =>
                                            <LLPList
                                                deleteLLP={deleteLLP}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                params={params}
                                                editLLP={editLLP}
                                                onEdit={() => setEditLLP({ modal: true, mode: 'edit', data: item })}
                                                onDelete={(e) => setDeleteLLP({ modal: true, data: item })}
                                                toggleBulkOps={toggleBulkOps}
                                                isSvApproved={isSvApproved}
                                                isClaimApproved={isClaimApproved}
                                                hideActionsColumn={hideActionsColumn}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                            </Paper>
                            {llpInfo?.length === 0 && <NoRecordFound />}
                        </>)}
                    </div>
                </div>
                {
                    addLLP.modal && shopVisit?.id && shopVisit?.asset_id ?
                        <LLPAddModal
                            params={params}
                            addLLP={addLLP}
                            modeType={"add"}
                            shopVisit={shopVisit}
                            getResponseBack={() => { getLlpList(shopVisit, queryConfig, 'pageLoader'); getShopVisitFundBalance(shopVisit); }}
                            onToggleModal={() => setAddLLP({ modal: false, mode: '', data: null })}
                        /> : null
                }
                {
                    editLLP.modal ?
                        <LLPEditModal
                            params={params}
                            editLLP={editLLP}
                            modeType={"edit"}
                            shopVisit={shopVisit}
                            llpList={llpInfo}
                            updateShopVisitLlpCost={updateShopVisitLlpCost}
                            getResponseBack={() => { const result = getLlpList(shopVisit, queryConfig, 'pageLoader'); getShopVisitFundBalance(shopVisit); return result; }}
                            onToggleModal={() => setEditLLP({ modal: false, mode: '', data: null })}
                        /> : null
                }
                {
                    bulkEditLLP.modal ?
                        <LLPBulkEditModal
                            bulkEditLLP={bulkEditLLP}
                            shopVisit={shopVisit}
                            allLlpList={llpInfo}
                            updateShopVisitLlpCost={updateShopVisitLlpCost}
                            getResponseBack={() => { const result = getLlpList(shopVisit, queryConfig, 'pageLoader'); getShopVisitFundBalance(shopVisit); resetBulkToggle(); return result; }}
                            onToggleModal={() => setBulkEditLLP({ modal: false, data: null })}
                        /> : null
                }
                {deleteLLP.modal || bulk.modal ?
                    <DeletePopUp
                        circularloader={isLoading?.buttonLoader}
                        modal={bulk.modal ? bulk.modal : deleteLLP.modal}
                        title={bulk.modal ? `Delete LLP (${bulk?.ids?.length})` : 'Delete LLP'}
                        content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                        onToggleModal={() => bulk.modal ? resetBulkToggle() : setDeleteLLP({ modal: false, data: null })}
                        onDeleteRecords={onDeleteLLP}
                    /> : null
                }
                {llpListLoader?.pageLoader ? <PageLoader /> : null}
            </Paper></>
    )
}
export default LLP;
